import { createContext, ReactNode, useContext } from 'react';

interface IScheduleSlotContext {
  disciplineSlug: string;
  compact?: boolean;
  selected?: boolean;
  currentProgress: number;
  totalProgress: number;
  type?: 'summary' | 'default';
}

const ScheduleSlotContext = createContext<IScheduleSlotContext>(
  {} as IScheduleSlotContext
);

export function useScheduleSlotContext() {
  return useContext(ScheduleSlotContext);
}

interface IScheduleSlotProviderProps {
  children?: ReactNode;
  disciplineSlug: string;
  compact?: boolean;
  selected?: boolean;
  currentProgress: number;
  totalProgress: number;
  type?: 'summary' | 'default';
}

export function ScheduleSlotProvider(props: IScheduleSlotProviderProps) {
  return (
    <ScheduleSlotContext.Provider
      value={{
        disciplineSlug: props.disciplineSlug,
        compact: props.compact,
        selected: props.selected,
        currentProgress: props.currentProgress,
        totalProgress: props.totalProgress,
        type: props.type,
      }}
    >
      {props.children}
    </ScheduleSlotContext.Provider>
  );
}
